export enum AgreementType {
  ESignConsentDisclosure = 'ESignConsentDisclosure',
  AcceptTermsOfUse = 'AcceptTermsOfUse',
  TranscriptAuthorization = 'TranscriptAuthorization',
}
